import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        >
        <path
            d="M19.999 3.333C10.815 3.333 3.332 10.816 3.332 20c0 9.183 7.483 16.666 16.667 16.666 9.183 0 16.666-7.483 16.666-16.666 0-9.184-7.483-16.667-16.666-16.667zm5.6 20.5a1.258 1.258 0 010 1.767c-.25.25-.567.366-.884.366-.316 0-.633-.116-.883-.366l-3.833-3.834-3.834 3.834c-.25.25-.566.366-.883.366-.317 0-.633-.116-.883-.366a1.258 1.258 0 010-1.767L18.232 20l-3.833-3.834a1.257 1.257 0 010-1.766 1.257 1.257 0 011.766 0L20 18.233l3.833-3.833a1.257 1.257 0 011.767 0 1.257 1.257 0 010 1.766L21.765 20l3.834 3.833z"
            fill={props.isHover ? '#B42318' : theme["#0D968F"]}
        />
        </svg>
    )
}

export default SvgComponent
